export const PRODUCTS = [
  {
    id: 'family-tree-templates-pack',
    name: 'Family Tree Templates Pack',
    blurb: 'Printable PDF, Word, Canva & PSD templates ready to fill and share.',
    badge: 'Popular',
    category: 'Templates Packs',
    image: '/images/products/box-templates-pack.png',
    basePrice: 199,
    options: {
      format: ['PDF', 'Word', 'Canva', 'PSD', 'All formats'],
      style: ['Classic', 'Modern', 'Elegant'],
    },
    optionPrices: {
      format: { PDF: 0, Word: 0, Canva: 0, PSD: 100, 'All formats': 200 },
      style: { Classic: 0, Modern: 0, Elegant: 100 },
    },
  },
  {
    id: 'family-tree-charts-pack',
    name: 'Family Tree Charts Pack',
    blurb: '3, 5 & 10-generation charts plus fan and pedigree layouts.',
    badge: 'Best value',
    category: 'Charts Packs',
    image: '/images/products/box-charts-pack.png',
    basePrice: 299,
    options: {
      generations: ['3-generation', '5-generation', '10-generation', 'Full chart set'],
      chartType: ['Pedigree Chart', 'Fan Chart', 'Both'],
    },
    optionPrices: {
      generations: {
        '3-generation': 0,
        '5-generation': 100,
        '10-generation': 200,
        'Full chart set': 300,
      },
      chartType: { 'Pedigree Chart': 0, 'Fan Chart': 100, Both: 200 },
    },
  },
  {
    id: 'family-tree-plugins-pack',
    name: 'Family Tree Plugins Pack',
    blurb: 'Add-on layouts, icons, and design plugins for tree builders.',
    badge: 'New',
    category: 'Plugins Packs',
    image: '/images/products/box-plugins-pack.png',
    basePrice: 199,
    options: {
      pack: ['Essential plugins', 'Pro plugins', 'Complete plugins'],
      delivery: ['Digital download'],
    },
    optionPrices: {
      pack: { 'Essential plugins': 0, 'Pro plugins': 100, 'Complete plugins': 200 },
      delivery: { 'Digital download': 0 },
    },
  },
  {
    id: 'family-tree-templates',
    name: 'Family Tree Templates',
    blurb: 'Printable PDF, Word, Canva, and PSD family tree templates.',
    badge: 'Templates',
    category: 'Templates',
    image: '/images/products/box-templates.png',
    basePrice: 199,
    options: {
      format: ['Printable PDF', 'Word', 'Canva', 'PSD'],
      pages: ['5 templates', '12 templates', '25 templates'],
    },
    optionPrices: {
      format: { 'Printable PDF': 0, Word: 0, Canva: 0, PSD: 100 },
      pages: { '5 templates': 0, '12 templates': 100, '25 templates': 200 },
    },
  },
  {
    id: 'family-tree-charts',
    name: 'Family Tree Charts',
    blurb: '3-generation, 5-generation, 10-generation, fan & pedigree charts.',
    badge: 'Charts',
    category: 'Charts',
    image: '/images/products/box-charts.png',
    basePrice: 299,
    options: {
      chart: [
        '3-generation',
        '5-generation',
        '10-generation',
        'Fan Chart',
        'Pedigree Chart',
      ],
      size: ['Letter', 'Tabloid', 'Poster'],
    },
    optionPrices: {
      chart: {
        '3-generation': 0,
        '5-generation': 100,
        '10-generation': 200,
        'Fan Chart': 100,
        'Pedigree Chart': 0,
      },
      size: { Letter: 0, Tabloid: 100, Poster: 200 },
    },
  },
  {
    id: 'custom-family-tree-design',
    name: 'Custom Family Tree Design',
    blurb: 'We professionally design your tree from the family data you share.',
    badge: 'Custom',
    category: 'Custom Design',
    image: '/images/products/box-custom-design.png',
    basePrice: 699,
    options: {
      people: ['Up to 20 people', 'Up to 50 people', 'Up to 100 people'],
      finish: ['Digital PDF', 'Print-ready file', 'PDF + print-ready'],
    },
    optionPrices: {
      people: { 'Up to 20 people': 0, 'Up to 50 people': 200, 'Up to 100 people': 400 },
      finish: { 'Digital PDF': 0, 'Print-ready file': 100, 'PDF + print-ready': 200 },
    },
  },
  {
    id: 'photo-family-tree-posters',
    name: 'Photo Family Tree Posters',
    blurb: 'Wall posters that combine your family photos with a tree layout.',
    badge: 'Posters',
    category: 'Posters',
    image: '/images/products/box-photo-posters.png',
    basePrice: 399,
    options: {
      size: ['16×20 in', '18×24 in', '24×36 in'],
      style: ['Classic frames', 'Modern collage', 'Elegant calligraphy'],
    },
    optionPrices: {
      size: { '16×20 in': 0, '18×24 in': 100, '24×36 in': 200 },
      style: { 'Classic frames': 0, 'Modern collage': 100, 'Elegant calligraphy': 100 },
    },
  },
  {
    id: 'family-history-books',
    name: 'Family History Books',
    blurb: 'Tell your family story as a hardcover keepsake or digital PDF.',
    badge: 'Books',
    category: 'Books',
    image: '/images/products/box-history-books.png',
    basePrice: 499,
    options: {
      format: ['PDF', 'Hardcover', 'PDF + Hardcover'],
      pages: ['40 pages', '80 pages', '120 pages'],
    },
    optionPrices: {
      format: { PDF: 0, Hardcover: 200, 'PDF + Hardcover': 300 },
      pages: { '40 pages': 0, '80 pages': 100, '120 pages': 200 },
    },
  },
  {
    id: 'family-reunion-books-invites',
    name: 'Family Reunion Books & Invitation Templates',
    blurb: 'Reunion memory books plus matching invitation templates.',
    badge: 'Reunion',
    category: 'Reunion',
    image: '/images/products/box-reunion-invites.png',
    basePrice: 399,
    options: {
      set: ['Invitations only', 'Reunion book only', 'Book + invitations'],
      format: ['PDF', 'Canva', 'PDF + Canva'],
    },
    optionPrices: {
      set: { 'Invitations only': 0, 'Reunion book only': 100, 'Book + invitations': 200 },
      format: { PDF: 0, Canva: 0, 'PDF + Canva': 100 },
    },
  },
  {
    id: 'family-tree-starter-pack',
    name: 'Family Tree Starter Pack',
    blurb: 'Beginner templates + simple 3-generation chart to start your first tree.',
    badge: 'Starter',
    category: 'Templates Packs',
    image: '/images/products/bundle-starter.png',
    basePrice: 199,
    options: {
      format: ['PDF', 'Canva', 'PDF + Canva'],
      extras: ['Templates only', 'Templates + chart'],
    },
    optionPrices: {
      format: { PDF: 0, Canva: 0, 'PDF + Canva': 100 },
      extras: { 'Templates only': 0, 'Templates + chart': 100 },
    },
  },
  {
    id: 'family-tree-complete-pack',
    name: 'Family Tree Complete Pack',
    blurb: 'Templates, charts, and plugins together in one complete family tree kit.',
    badge: 'Complete',
    category: 'Templates Packs',
    image: '/images/products/bundle-complete.png',
    basePrice: 499,
    options: {
      format: ['PDF', 'Canva', 'All formats'],
      level: ['Standard', 'Pro', 'Pro + posters guide'],
    },
    optionPrices: {
      format: { PDF: 0, Canva: 0, 'All formats': 200 },
      level: { Standard: 0, Pro: 100, 'Pro + posters guide': 200 },
    },
  },
  {
    id: 'family-tree-premium-pack',
    name: 'Family Tree Premium Pack',
    blurb: 'Premium templates, full chart set, plugins, and keepsake layout extras.',
    badge: 'Premium',
    category: 'Templates Packs',
    image: '/images/products/bundle-premium.png',
    basePrice: 699,
    options: {
      format: ['All formats', 'All formats + print guide'],
      bonus: ['Standard bonus', 'Poster layouts', 'Reunion invite extras'],
    },
    optionPrices: {
      format: { 'All formats': 0, 'All formats + print guide': 100 },
      bonus: { 'Standard bonus': 0, 'Poster layouts': 100, 'Reunion invite extras': 200 },
    },
  },
  {
    id: 'family-tree-canva-templates-pack',
    name: 'Family Tree Canva Templates Pack',
    blurb: 'Editable Canva family tree templates for quick online editing and sharing.',
    badge: 'Canva',
    category: 'Templates Packs',
    image: '/images/products/box-canva-templates.png',
    basePrice: 199,
    options: {
      count: ['10 templates', '20 templates', '35 templates'],
      style: ['Classic', 'Modern', 'Boho'],
    },
    optionPrices: {
      count: { '10 templates': 0, '20 templates': 100, '35 templates': 200 },
      style: { Classic: 0, Modern: 0, Boho: 100 },
    },
  },
  {
    id: 'family-tree-printable-pdf-pack',
    name: 'Family Tree Printable PDF Pack',
    blurb: 'Print-ready PDF family tree templates for home and shop printers.',
    badge: 'PDF',
    category: 'Templates Packs',
    image: '/images/products/box-pdf-pack.svg',
    basePrice: 199,
    options: {
      pages: ['12 PDFs', '24 PDFs', '40 PDFs'],
      size: ['Letter', 'Letter + Tabloid'],
    },
    optionPrices: {
      pages: { '12 PDFs': 0, '24 PDFs': 100, '40 PDFs': 200 },
      size: { Letter: 0, 'Letter + Tabloid': 100 },
    },
  },

  {
    id: 'family-tree-wedding-charts',
    name: 'Family Tree Wedding Charts',
    blurb: 'Elegant couple and family charts for weddings and guest books.',
    badge: 'Wedding',
    category: 'Charts',
    image: '/images/products/box-wedding-charts.svg',
    basePrice: 299,
    options: {
      style: ['Classic', 'Floral', 'Modern'],
      format: ['PDF', 'Canva', 'PDF + Canva'],
    },
    optionPrices: {
      style: { Classic: 0, Floral: 100, Modern: 100 },
      format: { PDF: 0, Canva: 0, 'PDF + Canva': 100 },
    },
  },
  {
    id: 'family-tree-baby-keepsake-pack',
    name: 'Family Tree Baby Keepsake Pack',
    blurb: 'Soft baby-themed tree templates for new parents and grandparents.',
    badge: 'Baby',
    category: 'Templates Packs',
    image: '/images/products/box-baby-keepsake.svg',
    basePrice: 199,
    options: {
      theme: ['Soft pastel', 'Nursery animals', 'Classic cream'],
      format: ['PDF', 'Canva', 'Both'],
    },
    optionPrices: {
      theme: { 'Soft pastel': 0, 'Nursery animals': 100, 'Classic cream': 0 },
      format: { PDF: 0, Canva: 0, Both: 100 },
    },
  },
  {
    id: 'family-tree-anniversary-posters',
    name: 'Family Tree Anniversary Posters',
    blurb: 'Anniversary wall posters celebrating marriage years and family branches.',
    badge: 'Anniversary',
    category: 'Posters',
    image: '/images/products/box-anniversary-posters.svg',
    basePrice: 399,
    options: {
      size: ['16×20 in', '18×24 in', '24×36 in'],
      years: ['25 years', '40 years', '50 years', 'Custom year'],
    },
    optionPrices: {
      size: { '16×20 in': 0, '18×24 in': 100, '24×36 in': 200 },
      years: { '25 years': 0, '40 years': 0, '50 years': 100, 'Custom year': 100 },
    },
  },
  {
    id: 'family-tree-photo-collage-pack',
    name: 'Family Tree Photo Collage Pack',
    blurb: 'Photo collage tree layouts for albums, frames, and digital shares.',
    badge: 'Collage',
    category: 'Posters',
    image: '/images/products/box-photo-collage.svg',
    basePrice: 399,
    options: {
      photos: ['Up to 12 photos', 'Up to 24 photos', 'Up to 40 photos'],
      format: ['PDF', 'Canva', 'Print-ready'],
    },
    optionPrices: {
      photos: { 'Up to 12 photos': 0, 'Up to 24 photos': 100, 'Up to 40 photos': 200 },
      format: { PDF: 0, Canva: 0, 'Print-ready': 100 },
    },
  },
  {
    id: 'family-tree-invitation-templates-pack',
    name: 'Family Tree Invitation Templates Pack',
    blurb: 'Invitation templates with family tree motifs for reunions and events.',
    badge: 'Invites',
    category: 'Reunion',
    image: '/images/products/box-invitation-templates.svg',
    basePrice: 199,
    options: {
      count: ['8 invites', '16 invites', '24 invites'],
      format: ['PDF', 'Canva', 'Word'],
    },
    optionPrices: {
      count: { '8 invites': 0, '16 invites': 100, '24 invites': 200 },
      format: { PDF: 0, Canva: 0, Word: 0 },
    },
  },
  {
    id: 'family-tree-certificate-templates',
    name: 'Family Tree Certificate Templates',
    blurb: 'Certificate-style templates for births, marriages, and family milestones.',
    badge: 'Certificates',
    category: 'Templates',
    image: '/images/products/box-certificate-templates.svg',
    basePrice: 199,
    options: {
      set: ['Birth set', 'Marriage set', 'Full milestone set'],
      format: ['PDF', 'Word', 'Canva'],
    },
    optionPrices: {
      set: { 'Birth set': 0, 'Marriage set': 0, 'Full milestone set': 100 },
      format: { PDF: 0, Word: 0, Canva: 0 },
    },
  },
];

/** Featured packs section — exactly 4 */
const FEATURED_IDS = [
  'family-tree-templates-pack',
  'family-tree-charts-pack',
  'family-tree-plugins-pack',
  'family-tree-complete-pack',
];

/** Regular shop grid */
const SHOP_IDS = [
  'family-tree-templates-pack',
  'family-tree-charts-pack',
  'family-tree-plugins-pack',
  'family-tree-templates',
  'family-tree-charts',
  'custom-family-tree-design',
  'photo-family-tree-posters',
  'family-history-books',
  'family-reunion-books-invites',
  'family-tree-starter-pack',
  'family-tree-complete-pack',
  'family-tree-canva-templates-pack',
];

function pickByIds(ids) {
  return ids.map((id) => PRODUCTS.find((p) => p.id === id)).filter(Boolean);
}

export const FEATURED_BUNDLES = pickByIds(FEATURED_IDS);
export const SHOP_PRODUCTS = pickByIds(SHOP_IDS);

export const CATEGORIES = [
  { id: 'all', label: 'All items' },
  ...Array.from(new Set(SHOP_PRODUCTS.map((p) => p.category))).map((cat) => ({
    id: cat,
    label: cat,
  })),
];

export const HERITAGE_POINTS = [
  {
    title: 'Start with ready templates',
    text: 'Fill printable PDF, Word, Canva, or PSD family tree templates — no blank page stress.',
    image: '/images/writing.jpg',
  },
  {
    title: 'Print charts for every generation',
    text: 'Choose 3, 5, or 10-generation layouts, fan charts, and pedigree charts for walls and albums.',
    image: '/images/hands-photos.jpg',
  },
  {
    title: 'Turn photos into keepsakes',
    text: 'Order photo posters, custom designs, history books, and reunion invitations your family will keep.',
    image: '/images/bookshelf.jpg',
  },
];

export const SUPPORT_ISSUES = [
  {
    title: 'Choosing a template format',
    text: 'PDF, Word, Canva, or PSD — we help you pick what matches how you like to edit and print.',
  },
  {
    title: 'Chart generations & sizes',
    text: '3, 5, or 10-generation trees, fan vs pedigree, letter to poster print sizes.',
  },
  {
    title: 'Custom design uploads',
    text: 'How to send names, dates, and photos so we can design your tree professionally.',
  },
  {
    title: 'Photo poster layouts',
    text: 'Frame styles, photo counts, and print-ready file tips for wall posters.',
  },
  {
    title: 'History book options',
    text: 'PDF vs hardcover, page counts, and what content to gather before ordering.',
  },
  {
    title: 'Reunion invites & books',
    text: 'Matching invitation templates and memory-book layouts for family gatherings.',
  },
  {
    title: 'Plugins & add-ons',
    text: 'Which plugin pack fits your editor and how downloads are delivered by email.',
  },
  {
    title: 'Order & file delivery',
    text: 'Cart, contact, digital downloads, and print-ready file handoff after confirmation.',
  },
];

export const TRANSFER_STEPS = [
  {
    step: '01',
    title: 'Pick your product',
    text: 'Choose templates, charts, plugins, posters, books, or a custom design from the shop.',
  },
  {
    step: '02',
    title: 'Select options',
    text: 'Set format, generations, size, or page count so the estimate matches what you need.',
  },
  {
    step: '03',
    title: 'Add to cart',
    text: 'Save items in your cart, then open Contact to send your order request.',
  },
  {
    step: '04',
    title: 'Receive your files',
    text: 'We confirm details by email and deliver downloads or custom design files when ready.',
  },
];

export const SYSTEM_REQUIREMENTS = [
  {
    title: 'Digital templates',
    items: [
      'PDF reader for printable templates',
      'Microsoft Word or compatible app for .docx packs',
      'Canva account for Canva template links',
      'Photoshop or PSD-compatible editor for PSD files',
    ],
  },
  {
    title: 'Printing',
    items: [
      'Home printer for letter/tabloid charts',
      'Local print shop for poster and hardcover options',
      'Color printing recommended for photo posters',
    ],
  },
  {
    title: 'Custom design',
    items: [
      'List of names, relationships, and dates',
      'Photo files (JPG/PNG) if ordering photo posters',
      'Email access for drafts and final delivery',
    ],
  },
];

export const SUPPORT_GUIDES = [
  {
    title: 'Fill a template in 15 minutes',
    text: 'Open your PDF or Canva file, replace sample names, and export a print-ready tree.',
  },
  {
    title: 'Pick the right generation chart',
    text: 'Use 3-generation for kids’ projects, 5 for family walls, and 10 for deep ancestry displays.',
  },
  {
    title: 'Prep photos for posters',
    text: 'Crop faces clearly, use similar lighting, and label files by person before you order.',
  },
  {
    title: 'Plan a reunion invite set',
    text: 'Match invitation wording, RSVP details, and a short memory-book page for guests.',
  },
];

export const FAQ_ITEMS = [
  {
    q: 'How do Family Tree packs work without checkout?',
    a: 'Choose your options, add the pack to your cart, then contact us to complete the order. We confirm format and delivery by email — then send your files.',
  },
  {
    q: 'Which pack is best for beginners?',
    a: 'Start with the Family Tree Templates Pack (PDF or Canva). It is easy to edit and print without design software.',
  },
  {
    q: 'What formats are included in Family Tree Templates?',
    a: 'You can choose Printable PDF, Word, Canva, or PSD — or get an All formats option on the Templates Pack.',
  },
  {
    q: 'What chart types do you offer?',
    a: '3-generation, 5-generation, 10-generation, Fan Chart, and Pedigree Chart — sold as single charts or as a Charts Pack.',
  },
  {
    q: 'How does Custom Family Tree Design work?',
    a: 'You share family names, dates, and optional photos. Our team professionally designs your tree and delivers a digital or print-ready file.',
  },
  {
    q: 'Can I order hardcover Family History Books?',
    a: 'Yes. Choose PDF, Hardcover, or both. Page-count options are available on the product page.',
  },
  {
    q: 'Do you have reunion invitations?',
    a: 'Yes — Family Reunion Books & Invitation Templates includes invitations only, a reunion book, or both together.',
  },
];
